export const MAP_TOUR_TARGET_ATTR = "data-ne-tour-target";
export const MAP_TOUR_STAT_LABEL_ATTR = "data-ne-tour-stat-label";
export const MAP_TOUR_CHANGE_OPTION_ATTR = "data-ne-tour-change-option";
export const MAP_TOUR_LOCK_ATTR = "data-ne-tour-lock";

export const MAP_TOUR_LOCKS = {
  primaryStatMenu: "primary-stat-menu",
  showingPanel: "showing-panel",
  sharePanel: "share-panel",
} as const;

export const MAP_TOUR_TARGETS = {
  brandLogo: "map-brand-logo",
  sidebarStatDetails: "map-sidebar-stat-details",
  sidebarAdvancedToggle: "map-sidebar-advanced-toggle",
  sidebarStatViz: "map-sidebar-stat-viz",
  sidebarAddAreas: "map-sidebar-add-areas",
  sidebarDemographicsExpand: "map-sidebar-demographics-expand",
  sidebarOtherStats: "map-sidebar-other-stats",
  sidebarOrgsTab: "map-sidebar-orgs-tab",
  sidebarHoursFilter: "map-sidebar-hours-filter",
  sidebarCategoryFilter: "map-sidebar-category-filter",
  sidebarCategoryMenu: "map-sidebar-category-menu",
  primaryStatChip: "map-primary-stat-chip",
  primaryStatMenu: "map-primary-stat-menu",
  primaryStatOption: "map-primary-stat-option",
  primaryStatDeselect: "map-primary-stat-deselect",
  showingChip: "map-showing-chip",
  showingOrganizations: "map-showing-organizations",
  showingExtremas: "map-showing-extremas",
  showingAreas: "map-showing-areas",
  showingPanel: "map-showing-panel",
  showingAreasMenu: "map-showing-areas-menu",
  shareChip: "map-share-chip",
  legend: "map-legend",
} as const;
